import { compose } from 'redux';
import { HomePage as HomePageComponent } from './HomePage';
import { withContainer } from './withContainer';

const HomePage = compose(
  withContainer,
)(HomePageComponent);

export { HomePage, HomePageComponent };
export * from './withContainer';
